import { render } from "./InputQuantity.vue?vue&type=template&id=883bb590"
import script from "./InputQuantity.vue?vue&type=script&lang=js"
export * from "./InputQuantity.vue?vue&type=script&lang=js"

import exportComponent from "C:\\NicolPC\\VueWork2026\\Axxo\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__